<template>
  <div class="content" style="background-size: cover;" v-if="!notFound">
    <Header></Header>
    <div class="nav">
      <span class="">{{$t('Packs')}}</span>
    </div>
    <div class="pack-list" style="text-align: center;padding-bottom: 30px;">
      <div class="pk-li por" @click="goBuy('one')">
        <div class="disflex">
          <img class="pk-img" src="../../static/images/pk-img1.png">
          <div class="pk-r">
            <div class="">{{$t('pkfont2')}}</div>
            <div class="br">{{$t('pkfont3')}}</div>
          </div>
        </div>
        <div class="pk1-btn">
          <span class="tt">{{$t('pkfont1')}}</span>
          <div class="ac" style="width: 50%;"><button class="btn-yl fw7">{{$t('pkfont4')}}</button></div>
        </div>
      </div>
      <div class="pk-li por" @click="goBuy('vip')">
        <div class="disflex">
          <img class="pk-img" src="../../static/images/pk-img2.png">
          <div class="pk-r">
            <div class="">{{$t('pkfont22')}}</div>
            <div class="br">{{$t('pkfont23')}}</div>
          </div>
        </div>
        <div class="pk1-btn">
          <span class="tt">{{$t('pkfont21')}}</span>
          <div class="ac" style="width: 50%;"><button class="btn-yl fw7">{{$t('pkfont24')}}</button></div>
        </div>
      </div>
<!--      <div class="pk-li por" @click="goBuy('week')" >-->
<!--        <div class="disflex">-->
<!--          <img class="pk-img" src="../../static/images/pk-img3.png">-->
<!--          <div class="pk-r">-->
<!--            <div class="">{{$t('pkfont32')}}</div>-->
<!--            <div class="br">{{$t('pkfont33')}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="pk1-btn">-->
<!--          <span class="tt">{{$t('pkfont31')}}</span>-->
<!--          <div class="ac" style="width: 50%;"><button class="btn-yl fw7">{{$t('pkfont34')}}</button></div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="pk-li por" @click="goBuy('day')" >-->
<!--        <div class="disflex">-->
<!--          <img class="pk-img" src="../../static/images/pk-img4.png">-->
<!--          <div class="pk-r">-->
<!--            <div class="">{{$t('pkfont42')}}</div>-->
<!--            <div class="br">{{$t('pkfont43')}}</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="pk1-btn">-->
<!--          <span class="tt">{{$t('pkfont41')}}</span>-->
<!--          <div class="ac" style="width: 50%;"><button class="btn-yl fw7">{{$t('pkfont44')}}</button></div>-->
<!--        </div>-->
<!--      </div>-->

    </div>
  </div>
</template>
<script>
import Header from '../components/header'
export default {
  components:{
    Header
  },
  data() {

    return {
      notFound: false,

    }
  },
  watch: {},
  computed: {},
  mounted() {

  },
  created() {

  },
  methods: {
    back() {
      this.$router.push({path: '/'})
    },
    goBuy(type) {
      let that = this
      let data = {
        type:type
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', data, r => {
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 80);
        })
      })
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/packList.vue